module.exports = __webpack_public_path__ + "1dfb1ad54ed3c5614262b78093df9857.png";